import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  isApplicantSelector,
  isCorpClientSelector,
  isEYProSelector,
  isEYAdminSelector,
  isCorporateClientLineManagerSelector,
  isDeleteProfileSelector,
} from 'src/ui/features/Login/state/loginReselect';
import GlobalMenuPres from './GlobalMenuPres';

class GlobalMenuContainer extends Component {
  state = {
    isMenuOpen: false,
  };

  toggleDrawer = open => () => {
    this.setState({ isMenuOpen: open });
  };

  render() {
    let userRoles = JSON.parse(sessionStorage.getItem('userInfo')).permissions;
    let roleName = {roleName: "DELETE_PROFILE"}
    const deleteUserRole = userRoles.some(role => role.roleName === roleName.roleName);
    return (
      <GlobalMenuPres
        isEYPro={this.props.isEYPro}
        isEYAdmin={this.props.isEYAdmin}
        isApplicant={this.props.isApplicant}
        isCorpClient={this.props.isCorpClient}
        isCorporateClientLineManagerSelector={this.props.isCorporateClientLineManagerSelector}
        countInboxUnread={this.props.countInboxUnread}
        isMenuOpen={this.state.isMenuOpen}
        toggleDrawer={this.toggleDrawer}
        isDeleteProfile={deleteUserRole}
      />
    );
  }
}

// export default GlobalMenuContainer;
const mapStateToProps = state => {
  return {
    countInboxUnread: state.messaging.countInboxUnread,
    isEYPro: isEYProSelector(state),
    isEYAdmin: isEYAdminSelector(state),
    isApplicant: isApplicantSelector(state),
    isCorpClient: isCorpClientSelector(state),
    isCorporateClientLineManagerSelector: isCorporateClientLineManagerSelector(state),
    isDeleteProfile: isDeleteProfileSelector(state),
  };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalMenuContainer);
